import { render, staticRenderFns } from "./v-card5.vue?vue&type=template&id=097819de&scoped=true"
import script from "./v-card5.vue?vue&type=script&lang=js"
export * from "./v-card5.vue?vue&type=script&lang=js"
import style0 from "./v-card5.vue?vue&type=style&index=0&id=097819de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097819de",
  null
  
)

export default component.exports